import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";
import { Grid } from "@material-ui/core";
import CSSModules from "react-css-modules";
import HtmlParser from "react-html-parser";
import { number } from "../../../utils";

@CSSModules(styles, { allowMultiple: true })
class WeeklySummaryTable extends Component {
	componentWillMount() {}

	render() {	
		return (
			<div styleName="table-wrapper">
				<div styleName="table-title">
					Weekly Summary
				</div>
				<div styleName="table-column row-header">
					<div styleName="fake-header"></div>
					<div>
						<div styleName="resizing-row-header">Total</div>
					</div>
					{this.props.livePageConf.ticketsIncluded && <div>
						<div styleName="resizing-row-header">Tickets</div>
					</div>}
					<div>
						<div styleName="resizing-row-header">kWh</div>
					</div>
					<div>
						<div styleName="resizing-row-header">Ambient Min</div>
					</div>
					<div>
						<div styleName="resizing-row-header">Ambient Avg</div>
					</div>
					<div>
						<div styleName="resizing-row-header">Ambient Max</div>
					</div>
				</div>
			{this.props.columnHeaders.map((columnHeader, index) => 
				<div key={index} styleName="table-column">
					<div styleName="column-header">
						<div styleName="resizing-row-header">{columnHeader.text}</div>
					</div>
					<div>
						<div styleName="shrink-small"><span styleName="dollar">$</span> {this.format(this.props.costs[index], 2)}</div>
					</div>
					{this.props.livePageConf.ticketsIncluded &&<div>
						<div styleName="shrink-small">{this.format(this.props.tickets[index])}</div>
					</div>}
					<div>
						<div styleName="shrink-small">{this.format(this.props.usage[index], 0)}</div>
					</div>
					<div>
						<div styleName="shrink-small">{this.format(this.props.ambientMin[index], 1)} <div styleName="degrees">°C</div></div>
					</div>
					<div>
						<div styleName="shrink-small">{this.format(this.props.ambientAvg[index], 1)} <div styleName="degrees">°C</div></div>
					</div>
					<div>
						<div styleName="shrink-small">{this.format(this.props.ambientMax[index], 1)} <div styleName="degrees">°C</div></div>
					</div>
				</div>
			)}
			</div>
		);
	}
	
	format(x, decimals){
		if(!x){ return 0; }
		if(decimals !== null && decimals !== undefined){
			x = number.parseNumber(x, decimals);
		}
		var parts = x.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}

	componentDidMount(){
		this.props.startComponent();
	}

	componentWillUnmount(){
		this.props.stopComponent();
	}

}

const bindAction = dispatch => {
	return {
		startComponent: () => dispatch(actions.startComponent()),
		stopComponent: () => dispatch(actions.stopComponent()),
	};
};

const mapStateToProps = state => ({
	columnHeaders: state.weeklysummarytable.columnHeaders,
	costs: state.weeklysummarytable.costs,
	tickets: state.weeklysummarytable.tickets,
	usage: state.weeklysummarytable.usage,
	ambientMin: state.weeklysummarytable.ambientMin,
	ambientAvg: state.weeklysummarytable.ambientAvg,
	ambientMax: state.weeklysummarytable.ambientMax,
	livePageConf: state.live.livePageConf
});

export default connect(mapStateToProps, bindAction)(WeeklySummaryTable);



// WEBPACK FOOTER //
// ./src/components/LiveComponents/WeeklySummaryTable/WeeklySummaryTable.js